import React, { useState } from "react";
import { authService } from "../../service/authService";
import BSpinner from "../../components/spinners/BSpinner";
import { useHistory } from "react-router-dom";
import LoginForm from "../../forms/LoginForm";
import "./LoginPage.css";

function LoginPage() {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const tryLogin = (formData) => {
    setLoading(true);
    authService
      .login(formData)
      .then(() => {
        history.push("/customers");
      })
      .catch((error) => {
        setErrors(error.response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="h-screen bg-gray-200 m-0 w-screen flex items-center justify-center flex-col">
      <div className="bg-white rounded shadow-md flex items-center justify-center flex-col login-form relative">
        <LoginForm onSubmit={tryLogin} />
        {errors.length !== 0 && errors.map((errorMessage, index) => (
          <span key={index} className="m-0 text-center text-red-500 text-sm absolute bottom-1">
            {errorMessage}
          </span>
        ))}
        {loading && (
          <div className="absolute w-full">
            <BSpinner />
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginPage;
